interface Comment {
  name: string;
  avatar: string;
  time: string;
  movie: string;
  rating: number;
  content: string;
}

const comments: Comment[] = [
  {
    name: '星辰大海',
    avatar: 'ri-user-3-line',
    time: '2小时前',
    movie: '星际远征',
    rating: 5,
    content: '4K HDR画质简直绝了！太空场景的细节清晰到能看清每颗星星的纹理。麻花影院的蓝光画质体验真的让我惊艳，加载速度也快得离谱，完全没有缓冲。这部片子我刷了三遍，每一遍都有新发现！',
  },
  {
    name: '电影发烧友小陈',
    avatar: 'ri-user-3-line',
    time: '5小时前',
    movie: '长安十二时辰',
    rating: 5,
    content: '作为一个华语电影的深度爱好者，麻花影院的经典修复系列真的让我太感动了。4K修复版的画质超出了我的预期，服饰纹理、建筑细节都清晰可见。这才是看电影该有的体验！',
  },
  {
    name: '午夜观影人',
    avatar: 'ri-user-3-line',
    time: '昨天',
    movie: '暗夜追踪',
    rating: 4,
    content: '悬疑片对画质要求其实很高，暗部细节如果糊了就完全没氛围。麻花影院的蓝光画质把夜晚街道的光影层次还原得太好了，配合流畅的加载体验，全程沉浸感拉满。已经推荐给所有朋友！',
  },
  {
    name: '剧荒终结者',
    avatar: 'ri-user-3-line',
    time: '昨天',
    rating: 5,
    movie: '动物狂想曲',
    content: '带娃一起看的，4K画质下的动画色彩太漂亮了！每一帧都可以截图当壁纸。而且麻花影院的专题分类做得很好，轻松找到了适合全家一起看的电影列表。现在每周五晚是我们的家庭电影之夜！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-secondary-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-chat-heart-line text-secondary-600 text-sm"></i>
              <span className="text-secondary-700 text-xs font-medium">真实反馈</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              观众热评
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              来看看影迷们对麻花影院超清观影体验的真实评价
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {comments.map((comment) => (
              <div key={comment.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200/50 transition-colors duration-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${comment.avatar} text-primary-600 text-base`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-foreground-900 font-semibold text-sm whitespace-nowrap">{comment.name}</span>
                      <span className="bg-accent-100 text-accent-700 text-[10px] px-2 py-0.5 rounded-full whitespace-nowrap">
                        {comment.movie}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-1">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                        ></i>
                      ))}
                      <span className="text-foreground-400 text-xs ml-1">{comment.time}</span>
                    </div>
                  </div>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed">{comment.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}